import React from "react";

function JIOSaavn(props) {
	return (
		<div className="height-100">
			<iframe width="100%" height="650" scrolling="no" frameborder="no" allow="autoplay" src="https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/playlists/1927447815&color=%23ff5500&auto_play=false&hide_related=false&show_comments=true&show_user=true&show_reposts=false&show_teaser=true&visual=true"></iframe><div style={{fontSize: 12, fontFamily: 'Sans-serif', color: 'white'}}><a href="https://soundcloud.com/church-of-meme/sets/cult-6900-vibes-ai-music" title="Church Of Meme" target="_blank">Church Of Meme</a></div>
		</div>
	);
}

export default JIOSaavn;
